<template>
  <div class="expert-extraction">
    <!-- 页面标题 -->
    <div class="page-header">
      <div class="header-left">
        <h2>专家抽取列表</h2>
      </div>
    </div>
    <!-- 搜索区域 -->
    <div class="search-section">
      <div class="search-form">
        <div class="form-item">
          <label>标段名称：</label>
          <el-input v-model="searchForm.projectName" placeholder="请输入项目名称" style="width: 300px;" clearable />
        </div>
        <el-button type="primary" @click="handleSearch">
          <i class="el-icon-search"></i>
          查询
        </el-button>
      </div>
    </div>
    <!-- 数据表格 -->
    <div class="table-section">
      <el-table :data="tableData" border stripe style="width: 100%" class="extraction-table">
        <el-table-column prop="projectName" label="招标项目名称" show-overflow-tooltip />
        <el-table-column prop="sectionName" label="标段名称" show-overflow-tooltip />
        <el-table-column prop="major" label="专业" show-overflow-tooltip />
        <el-table-column prop="personCount" label="抽取总人数" align="center" />
        <el-table-column prop="status" label="状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="getStatusType(scope.row.status)" size="small">
              {{ getDocumentStatusText(scope.row.status) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="400" align="center">
          <template slot-scope="scope">
            <div class="action-buttons">
              <el-button type="text" size="small" @click="handleViewResult(scope.row)">
                <i class="el-icon-document"></i>
                查看抽取结果
              </el-button>
              <el-button type="text" size="small" @click="handleModifyRepresentative(scope.row)">
                <i class="el-icon-edit"></i>
                修改招标人代表
              </el-button>
              <el-button type="text" size="small" @click="handlePrintResult(scope.row)">
                <i class="el-icon-printer"></i>
                打印抽取结果
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="pagination-section">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="pagination.currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper" :total="pagination.total" background />
    </div>
    <!-- 抽取结果弹窗 -->
    <el-dialog title="抽取结果" :visible.sync="extractionResultDialog.visible" width="75%" :close-on-click-modal="false"
      class="extraction-result-dialog" :append-to-body="true">
      <div class="dialog-content">
        <!-- 专家信息表格 -->
        <el-table :data="extractionResultDialog.expertData" border stripe style="width: 100%" class="result-table">
          <el-table-column prop="serialNumber" label="序号" width="80" align="center" />
          <el-table-column prop="realName" label="专家姓名" show-overflow-tooltip />
          <el-table-column prop="phone" label="联系方式" show-overflow-tooltip />
          <el-table-column prop="idCard" label="身份证号" show-overflow-tooltip />
          <el-table-column prop="company" label="工作单位" show-overflow-tooltip />
          <el-table-column prop="professionalTitle" label="职称" show-overflow-tooltip />
          <el-table-column prop="participate" label="是否参加" align="center">
            <template slot-scope="scope">
              <el-tag :type="scope.row.participate ? 'success' : 'danger'" size="small">
                {{ scope.row.participate ? '是' : '否' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="avoid" label="是否回避" align="center">
            <template slot-scope="scope">
              <el-tag :type="Number(scope.row.avoid) === 1 ? 'warning' : 'info'" size="small">
                {{ Number(scope.row.avoid) === 1 ? '是' : '否' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="确认是否参加" align="center">
            <template slot-scope="scope">
              <div class="participation-buttons">
                <el-button type="info" size="mini" @click="handleConfirmParticipation(scope.row, false)"
                  v-if="scope.row.participate">
                  不参加
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="success" @click="handleSendSMS">
          <i class="el-icon-message"></i>
          发送短信
        </el-button>
      </div>
    </el-dialog>
    <!-- 修改招标人代表弹窗 -->
    <el-dialog title="修改招标人代表" :visible.sync="modifyRepresentativeDialog.visible" width="75%"
      :close-on-click-modal="false" append-to-body class="modify-representative-dialog">
      <div class="modify-representative-content">
        <el-table :data="modifyRepresentativeDialog.representativeData" style="width: 100%" border>
          <el-table-column label="序号" width="80" align="center">
            <template slot-scope="scope">
              {{ scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="representName" label="姓名" width="120" align="center">
          </el-table-column>
          <el-table-column prop="workUnit" label="工作单位" min-width="200" align="center">
          </el-table-column>
          <el-table-column prop="mobile" label="联系方式" width="150" align="center">
          </el-table-column>
          <el-table-column prop="idCard" label="身份证号" width="150" align="center">
          </el-table-column>
          <el-table-column label="操作" width="200" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="handleEditRepresentative(scope.row)">
                <i class="el-icon-edit"></i>
                修改招标人代表
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <!-- 编辑招标人代表弹窗 -->
    <el-dialog title="编辑招标人代表" :visible.sync="editRepresentativeDialog.visible" width="500px"
      :close-on-click-modal="false" append-to-body class="edit-representative-dialog">
      <div class="edit-representative-content">
        <el-form :model="editRepresentativeDialog.form" label-width="100px" class="edit-form">
          <el-form-item label="姓名：">
            <el-input v-model="editRepresentativeDialog.form.representName" placeholder="请输入姓名"
              maxlength="50"></el-input>
          </el-form-item>
          <el-form-item label="工作单位：">
            <el-input v-model="editRepresentativeDialog.form.workUnit" placeholder="请输入工作单位" maxlength="100"></el-input>
          </el-form-item>
          <el-form-item label="联系方式：">
            <el-input v-model="editRepresentativeDialog.form.mobile" placeholder="请输入联系方式" maxlength="20"></el-input>
          </el-form-item>
          <el-form-item label="身份证号：">
            <el-input v-model="editRepresentativeDialog.form.idCard" placeholder="请输入身份证号" maxlength="30"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer">
        <el-button @click="handleCancelEditRepresentative">取消</el-button>
        <el-button type="primary" @click="handleConfirmEditRepresentative">确定</el-button>
      </div>
    </el-dialog>
    <!-- 打印抽取结果弹窗 -->
    <el-dialog title="评标专家抽取情况表" :visible.sync="printDialog.visible" width="80%" class="print-dialog"
      :close-on-click-modal="false" :close-on-press-escape="false" :append-to-body="true">
      <div id="printContent" class="print-content">
        <!-- 标题 -->
        <h1 class="report-title">评标专家抽取情况表</h1>
        <!-- 项目基本信息 -->
        <table class="info-table">
          <tr>
            <td class="label">招标项目名称</td>
            <td class="value">{{ printDialog.reportData.projectName }}</td>
          </tr>
          <tr>
            <td class="label">标段名称</td>
            <td class="value">{{ printDialog.reportData.bidName }}</td>
          </tr>
          <tr>
            <td class="label">开标时间</td>
            <td class="value">{{ printDialog.reportData.bidOpeningTime }}</td>
          </tr>
          <tr>
            <td class="label">评标时间</td>
            <td class="value">{{ printDialog.reportData.evaluationTime }}</td>
          </tr>
          <!-- <tr>
            <td class="label">预计评标时间</td>
            <td class="value">{{ printDialog.reportData.estimatedEvaluationTime }}</td>
          </tr> -->
          <tr>
            <td class="label">评标地点</td>
            <td class="value">{{ printDialog.reportData.evaluationLocation }}</td>
          </tr>
          <tr>
            <td class="label">代理机构联系人</td>
            <td class="value">{{ printDialog.reportData.agencyContactPerson }}</td>
          </tr>
          <tr>
            <td class="label">代理机构联系电话</td>
            <td class="value">{{ printDialog.reportData.agencyContactPhone }}</td>
          </tr>
          <tr>
            <td class="label">招标人代表数量</td>
            <td class="value">{{ printDialog.reportData.bidderRepresentativeCount }}</td>
          </tr>
          <tr>
            <td class="label">抽取地区</td>
            <td class="value">{{ printDialog.reportData.extractionRegion }}</td>
          </tr>
          <tr>
            <td class="label">回避单位</td>
            <td class="value">{{ printDialog.reportData.recusalUnits }}</td>
          </tr>
        </table>

        <!-- 专家信息 -->
        <h2 class="section-title">专家信息</h2>
        <table class="expert-table">
          <thead>
            <tr>
              <th>序号</th>
              <th>专家姓名</th>
              <th>性别</th>
              <!-- <th>联系方式</th> -->
              <th>工作单位</th>
              <th>专业</th>
              <!-- <th>地区</th> -->
            </tr>
          </thead>
          <tbody>
            <tr v-for="expert in printDialog.reportData.experts" :key="expert.serialNumber">
              <td>{{ expert.serialNumber }}</td>
              <td>{{ expert.name }}</td>
              <td>{{ expert.gender }}</td>
              <!-- <td>{{ expert.contactMethod }}</td> -->
              <td>{{ expert.workUnit }}</td>
              <td>{{ expert.specialty }}</td>
              <!-- <td>{{ expert.region }}</td> -->
            </tr>
          </tbody>
        </table>

        <!-- 底部签名 -->
        <div class="footer-info">
          <p>(参与)专家抽取操作人：{{ printDialog.reportData.extractionOperator }}</p>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" icon="el-icon-printer" @click="handlePrint">打印</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getExpertSelectionAuditList, getSelectionResult, setLeave, setParticipate, getRepresentList, updateRepresent, sendSms, getExpertSelectionDetail } from '@/api/modules/expertSelection'

export default {
  name: 'ExpertExtraction',
  data() {
    return {
      // 搜索表单
      searchForm: {
        projectName: ''
      },
      expertSelectionMainId: '',
      // 表格数据
      tableData: [],
      // 分页数据
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      // 抽取结果弹窗
      extractionResultDialog: {
        visible: false,
        expertData: []
      },
      // 修改招标人代表弹窗
      modifyRepresentativeDialog: {
        visible: false,
        currentProject: null,
        representativeData: []
      },
      // 编辑招标人代表弹窗
      editRepresentativeDialog: {
        visible: false,
        currentRepresentative: null,
        form: {
          id: '',
          representName: '',
          workUnit: '',
          mobile: '',
          idCard: '',
          selectionMainId: ''
        }
      },
      // 打印抽取结果弹窗
      printDialog: {
        visible: false,
        reportData: {
          projectName: '',
          bidName: '',
          bidOpeningTime: '',
          evaluationTime: '',
          estimatedEvaluationTime: '',
          evaluationLocation: '',
          agencyContactPerson: '',
          agencyContactPhone: '',
          bidderRepresentativeCount: 1,
          extractionRegion: '',
          recusalUnits: '',
          extractionOperator: '',
        }
      }
    }
  },
  computed: {
    channelCode() {
      return this.$channelMaterial.getChannelCode()
    },
  },
  mounted() {
    // 页面初始化
    this.loadData()
  },
  methods: {
    // 加载数据
    loadData() {
      this.getExpertSelectionAuditList()
    },
    // 搜索
    handleSearch() {
      this.loadData()
    },
    //获取列表
    getExpertSelectionAuditList() {
      getExpertSelectionAuditList({
        pageIndex: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
        projectName: this.searchForm.projectName,
        channelCode: this.channelCode,
        type: 2,
      }).then(res => {
        if (res.code === 200) {
          this.pagination.total = res.data.total || 0;
          this.tableData = res.data.records || [];
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 查看抽取结果
    handleViewResult(row) {
      const loading = this.$loading({
        lock: true,
        text: '正在加载...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.expertSelectionMainId = row.id
      setTimeout(() => {
        loading.close()
        this.extractionResultDialog.visible = true
        this.getSelectionResult(row.id)
      }, 1)
    },
    //详情列表
    getSelectionResult(id) {
      getSelectionResult({
        id: id,
        channelCode: this.channelCode
      }).then(res => {
        if (res.code === 200) {
          const list = Array.isArray(res.data) ? res.data : []
          this.extractionResultDialog.expertData = list.map((item, index) => {
            return {
              ...item,
              serialNumber: index + 1
            }
          })
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 修改招标人代表
    handleModifyRepresentative(row) {
      this.modifyRepresentativeDialog.currentProject = row
      this.getRepresentList(row.id)

    },
    // 获取招标代表列表
    getRepresentList(expertSelectionMainId) {
      getRepresentList({ expertSelectionMainId: expertSelectionMainId, channelCode: this.channelCode }).then(res => {
        if (res.code == 200) {
          this.modifyRepresentativeDialog.visible = true
          this.modifyRepresentativeDialog.representativeData = res.data
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 打印抽取结果
    handlePrintResult(row) {
      this.getExpertSelectionDetail(row.id)
    },
    //获取评标专家抽取详情
    getExpertSelectionDetail(id) {
      getExpertSelectionDetail(id).then(res => {
        if (res.code === 200) {
          const data = res.data
          const sectionName = Array.isArray(data.sectionName) ? data.sectionName.join('、') : data.sectionName || ''
          const estimatedTime = data.durationTime === 1 ? '半天' : data.durationTime === 2 ? '一天' : ''
          let extractionRegion = ''
          if (Array.isArray(data.countyList) && data.countyList.length > 0) {
            extractionRegion = data.countyList.map(county => {
              return `${county.provinceName}-${county.cityName}-${county.countyName}`
            }).join('、')
          }
          const recusalUnits = Array.isArray(data.companyList) ? data.companyList.join('、') : ''
          let experts = []
          if (Array.isArray(data.expertPoList) && data.expertPoList.length > 0) {
            experts = data.expertPoList.map((expert, index) => {
              const gender = expert.sex === 2 ? '女' : '男'
              let region = ''
              const province = expert.province || ''
              const city = expert.city || ''
              const county = expert.county || ''
              if (province || city || county) {
                region = [province, city, county].filter(item => item).join(',')
              }
              return {
                serialNumber: index + 1,
                name: expert.realName || '',
                gender: gender,
                contactMethod: expert.phone || '',
                workUnit: expert.company || '',
                specialty: expert.industryName || '',
                region: region
              }
            })
          }
          this.printDialog.reportData = {
            projectName: data.projectName || '',
            bidName: sectionName,
            bidOpeningTime: data.openTime || '',
            evaluationTime: data.reviewTime || '',
            estimatedEvaluationTime: estimatedTime,
            evaluationLocation: data.address || '',
            agencyContactPerson: data.contactName || '',
            agencyContactPhone: data.contactMobile || '',
            bidderRepresentativeCount: data.representCount || 0,
            extractionRegion: extractionRegion,
            recusalUnits: recusalUnits,
            extractionOperator: data.operator || '',
            experts: experts
          }

          // 打开弹窗
          this.printDialog.visible = true
        } else {
          this.$message.error(res.msg)
        }
      })
    },

    // 分页大小改变
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.loadData()
    },
    // 当前页改变
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.loadData()
    },
    // 确认是否参加
    handleConfirmParticipation(row, isParticipating) {
      const loading = this.$loading({
        lock: true,
        text: '正在补充抽取中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
        customClass: 'top-loading-mask',
      })

      setTimeout(() => {
        setParticipate({
          evaluationExpertId: row.id,
          participate: isParticipating,
          expertSelectionMainId: row.expertSelectionMainId
        }).then(res => {
          loading.close()
          if (res.code === 200) {
            row.participate = isParticipating
            this.$message.success(`已${isParticipating ? '确认参加' : '确认不参加'}`)
            // 重新调用接口刷新数据
            this.getSelectionResult(row.expertSelectionMainId)
          } else {
            this.$message.error(res.msg)
          }
        }).catch(error => {
          loading.close()
          this.$message.error('操作失败')
        })
      }, 3000)
    },
    // 发送短信
    handleSendSMS() {
      this.sendSms()
    },
    sendSms() {
      sendSms({
        expertSelectionMainId: this.expertSelectionMainId
      }).then(res => {
        if (res.code === 200) {
          this.$message.success('短信发送成功')
        } else {
          this.$message.warning(res.msg)
        }
      })
    },
    // 编辑招标人代表
    handleEditRepresentative(row) {
      this.editRepresentativeDialog.currentRepresentative = row
      // 回显数据
      this.editRepresentativeDialog.form = {
        id: row.id || '',
        representName: row.representName || '',
        workUnit: row.workUnit || '',
        mobile: row.mobile || '',
        idCard: row.idCard || '',
        selectionMainId: this.modifyRepresentativeDialog.currentProject?.expertSelectionMainId || ''
      }
      this.editRepresentativeDialog.visible = true
    },
    // 取消编辑招标人代表
    handleCancelEditRepresentative() {
      this.editRepresentativeDialog.visible = false
      this.editRepresentativeDialog.currentRepresentative = null
      this.editRepresentativeDialog.form = {
        id: '',
        representName: '',
        workUnit: '',
        mobile: '',
        idCard: '',
        selectionMainId: ''
      }
    },
    // 确认编辑招标人代表
    handleConfirmEditRepresentative() {
      const form = this.editRepresentativeDialog.form
      // 表单验证
      if (!form.representName || !form.representName.trim()) {
        this.$message.warning('请输入姓名')
        return
      }
      if (!form.workUnit || !form.workUnit.trim()) {
        this.$message.warning('请输入工作单位')
        return
      }
      if (!form.mobile || !form.mobile.trim()) {
        this.$message.warning('请输入联系方式')
        return
      }
      const params = {
        id: form.id,
        representName: form.representName,
        workUnit: form.workUnit,
        mobile: form.mobile,
        idCard: form.idCard,
        selectionMainId: form.selectionMainId,
        channelCode: this.channelCode
      }
      updateRepresent(params).then(res => {
        if (res.code === 200) {
          this.$message.success('修改成功')
          this.editRepresentativeDialog.visible = false
          this.editRepresentativeDialog.currentRepresentative = null
          this.editRepresentativeDialog.form = {
            id: '',
            representName: '',
            workUnit: '',
            mobile: '',
            idCard: '',
            selectionMainId: ''
          }
          this.getRepresentList(form.id)
        } else {
          this.$message.error(res.msg || '修改失败')
        }
      }).catch(err => {
        console.error('修改招标人代表失败:', err)
        this.$message.error('修改失败')
      })
    },
    // 补充抽取
    handleSupplementaryExtraction() {
      console.log('补充抽取')
      this.$message.info('补充抽取功能')
    },
    // 打印抽取结果
    handlePrintExtractionResult() {
      console.log('打印抽取结果')
      this.printDialog.visible = true
    },
    // 打印
    handlePrint() {
      try {
        // 获取打印内容
        const printContent = document.getElementById('printContent')
        if (!printContent) {
          this.$message.error('未找到打印内容')
          return
        }

        // 创建新窗口进行打印
        const printWindow = window.open('', '_blank')

        // 写入HTML内容
        printWindow.document.write(`
          <!DOCTYPE html>
          <html>
          <head>
            <meta charset="utf-8">
            <title>评标专家抽取情况表</title>
            <style>
              * {
                margin: 0;
                padding: 0;
                box-sizing: border-box;
              }
              body {
                font-family: "Microsoft YaHei", Arial, sans-serif;
                padding: 20px;
                font-size: 14px;
              }
              .report-title {
                font-size: 24px;
                font-weight: bold;
                text-align: center;
                margin-bottom: 30px;
              }
              table {
                width: 100%;
                border-collapse: collapse;
                margin-bottom: 0;
              }
              table td, table th {
                border: 1px solid #ddd;
                padding: 8px 12px;
                text-align: left;
              }
              .info-label {
                font-weight: bold;
                background: #f5f7fa;
                width: 200px;
              }
              .info-value {
                background: #fff;
              }
              .expert-table {
                margin-top: 20px;
              }
              .expert-table th {
                background: #f5f7fa;
                font-weight: bold;
                text-align: center;
              }
              .expert-table td {
                text-align: center;
              }
              .signature-section {
                margin-top: 40px;
              }
              .signature-item {
                margin-bottom: 20px;
              }
              @media print {
                @page {
                  size: A4;
                  margin: 20mm;
                }
              }
            </style>
          </head>
          <body>
            ${printContent.innerHTML}
          </body>
          </html>
        `)

        printWindow.document.close()

        // 等待内容加载完成后打印
        printWindow.onload = function () {
          printWindow.focus()
          printWindow.print()
          printWindow.close()
        }

        // 兼容性处理：如果 onload 不触发，延迟打印
        setTimeout(() => {
          if (!printWindow.closed) {
            printWindow.focus()
            printWindow.print()
            printWindow.close()
          }
        }, 500)
      } catch (error) {
        console.error('打印失败:', error)
        this.$message.error('打印失败，请重试')
      }
    },
    // 生成云签章PDF
    handleGeneratePDF() {
      console.log('生成云签章PDF')
      this.$message.success('正在生成云签章PDF...')
    },
    /**
* 获取文件编制状态文本
*/
    getDocumentStatusText(status) {
      const statusMap = {
        0: '待审核',
        1: '审核通过',
        2: '审核未通过',
      }
      return statusMap[status] || '-'
    },

    getStatusType(status) {
      const statusMap = {
        0: 'info',
        1: 'warning',
        2: 'success'
      }
      return statusMap[status] || 'info'
    }
  }
}
</script>

<style lang="less" scoped>
@import '@/styles/minimal-gray-theme.less';

.expert-extraction {
  .apply-minimal-gray-theme();
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;

  .header-left {
    flex: 1;
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
  }

  h2 {
    font-size: 20px;
    font-weight: 600;
    color: @gray-700;
    margin: 0;
    line-height: 1.5;
    position: relative;
    padding-left: 10px;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 3px;
      height: 16px;
      background: @primary-color;
      border-radius: 2px;
    }
  }
}

.search-section {
  margin-bottom: 16px;
  padding: 16px 20px;
  background: #fff;
  border-radius: 4px;
  box-shadow: @shadow-sm;
}

.search-form {
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
}

.form-item {
  display: flex;
  align-items: center;
  gap: 10px;
}

.form-item label {
  font-size: 14px;
  color: @gray-600;
  font-weight: 500;
  white-space: nowrap;
}

/deep/ .el-input__inner {
  border-color: @gray-300;
  color: @gray-700;

  &:focus {
    border-color: @primary-color;
  }

  &::placeholder {
    color: @gray-400;
  }
}

.table-section {
  margin-bottom: 16px;
  background: #fff;
  padding: 20px;
  border-radius: 4px;
  box-shadow: @shadow-sm;
}

.pagination-section {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
  background: #fff;
  padding: 16px 20px;
  border-radius: 4px;
  box-shadow: @shadow-sm;
}

.action-buttons {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex-wrap: nowrap;
}

/deep/ .el-button--text {
  color: @gray-600;
  padding: 0 8px;
  margin: 0;
  white-space: nowrap;

  &:hover {
    color: @primary-color;
  }

  i {
    margin-right: 4px;
  }
}

.extraction-table,
.result-table,
.modify-representative-content /deep/ .el-table {
  border-radius: 4px;
  overflow: hidden;

  /deep/ th {
    background: @gray-50 !important;
    color: @gray-700 !important;
    font-weight: 600;
    border-color: @gray-200 !important;
  }

  /deep/ td {
    color: @gray-600;
    border-color: @gray-200 !important;
  }
}

/deep/ .el-tag--success {
  background: fade(@success-color, 10%);
  border-color: fade(@success-color, 20%);
  color: @success-color;
}

/deep/ .el-tag--warning {
  background: fade(@warning-color, 10%);
  border-color: fade(@warning-color, 20%);
  color: @warning-color;
}

/deep/ .el-tag--info {
  background: @gray-100;
  border-color: @gray-200;
  color: @gray-600;
}

.extraction-result-dialog,
.modify-representative-dialog,
.edit-representative-dialog,
.print-dialog {
  /deep/ .el-dialog {
    border-radius: 8px;
  }

  /deep/ .el-dialog__header {
    background: @gray-50;
    border-bottom: 1px solid @gray-200;
    padding: 16px 20px;
  }

  /deep/ .el-dialog__title {
    font-size: 16px;
    font-weight: 600;
    color: @gray-700;
  }

  /deep/ .el-dialog__body {
    padding: 20px;
  }
}

.dialog-content {
  max-height: 500px;
  overflow-y: auto;
}

.dialog-footer {
  text-align: center;
  padding: 15px 0;
  border-top: 1px solid @gray-200;

  .el-button {
    padding: 10px 30px;
    font-size: 14px;
  }
}

.participation-buttons {
  display: flex;
  gap: 8px;
  justify-content: center;

  .el-button {
    padding: 5px 15px;
    font-size: 12px;
  }
}

.evaluation-content {
  padding: 10px 0;

  label {
    display: block;
    margin-bottom: 15px;
    font-size: 14px;
    color: @gray-600;
    font-weight: 500;
  }

  /deep/ .el-radio {
    margin-right: 0;
    margin-bottom: 15px;
    display: block;
  }

  /deep/ .el-radio__label {
    font-size: 14px;
    padding-left: 8px;
    color: @gray-600;
  }

  /deep/ .el-radio__input.is-checked .el-radio__inner {
    border-color: @primary-color;
    background: @primary-color;
  }

  /deep/ .el-radio__input.is-checked+.el-radio__label {
    color: @primary-color;
    font-weight: 600;
  }
}

.modify-representative-content {
  min-height: 300px;
}

.edit-representative-content {
  padding: 10px 0;
}

.edit-form {
  /deep/ .el-form-item {
    margin-bottom: 20px;
  }

  /deep/ .el-form-item__label {
    font-weight: 500;
    color: @gray-600;
  }

  /deep/ .el-input__inner {
    border-radius: 4px;
    border: 1px solid @gray-300;

    &:focus {
      border-color: @primary-color;
      box-shadow: 0 0 0 2px fade(@primary-color, 15%);
    }
  }
}

.print-dialog {
  /deep/ .el-dialog__body {
    background-color: @gray-100;
  }
}

.print-content {
  background-color: #fff;
  padding: 40px;
  max-width: 1200px;
  margin: 0 auto;
}

.report-title {
  text-align: center;
  font-size: 26px;
  font-weight: 600;
  color: @gray-700;
  margin: 0 0 40px 0;
}

.info-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 30px;

  tr {
    border-bottom: 1px solid @gray-200;
  }

  tr:last-child {
    border-bottom: none;
  }

  td {
    padding: 12px 15px;
    line-height: 1.6;
  }

  td.label {
    width: 180px;
    font-weight: 500;
    color: @gray-600;
    background-color: @gray-50;
  }

  td.value {
    color: @gray-700;
  }
}

.section-title {
  font-size: 18px;
  font-weight: 600;
  color: @gray-700;
  margin: 30px 0 15px 0;
}

.expert-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 30px;

  th,
  td {
    border: 1px solid @gray-200;
    padding: 10px 8px;
    text-align: center;
    font-size: 14px;
  }

  th {
    background-color: @gray-50;
    font-weight: 600;
    color: @gray-700;
  }

  td {
    color: @gray-600;
  }
}

.footer-info {
  margin-top: 40px;
  padding-top: 20px;
  border-top: 1px solid @gray-200;

  p {
    margin: 0;
    color: @gray-600;
    font-size: 14px;
  }
}
</style>

<style>
.top-loading-mask {
  z-index: 9999 !important;
}
</style>